import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Box, Button, Typography } from '@mui/material';

/**
 * The properties for the failed payment components
 */
interface FailedPaymentProps {
  /**
   * A function to handle resetting so that the manager can add more licenses
   */
  reset: () => void;
}

/**
 * A component to show when we've detected that their payment has failed
 */
const FailedPayment = (props: FailedPaymentProps) => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
    <ErrorOutlineRoundedIcon color="error" style={{ fontSize: 60 }} />
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography fontWeight="bold" fontSize="1.5em" textAlign="center">
        Payment Failed
      </Typography>
      <Typography color="textSecondary" textAlign="center" gutterBottom>
        We couldn&apos;t process your payment. This may be due to insufficient
        funds, an invalid payment method, or an issue with your payment
        provider. Please try again or contact support for assistance.
      </Typography>
    </Box>
    <Button variant="contained" onClick={props.reset}>
      Try Again
    </Button>
  </Box>
);

export default FailedPayment;
